import React from 'react';
// import footerData from '../App_Strings.json';


import { IAppConfig } from "../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}




const Footer_v01: React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <footer className="bg-dark text-light text-center py-3 mt-auto">
      <div className="container">
        <p className="mb-1">Copyright &copy; {new Date().getFullYear()}, {appConfig.companyLegalName}, All rights reserved. {appConfig.versionNumber}</p>
        <ul className="list-inline mb-0">
          <li className="list-inline-item"><a href="https://www.LegacyInsuranceNetwork.com/privacy" className="text-light text-decoration-none">Privacy Policy</a></li>
          <li className="list-inline-item">|</li>
          <li className="list-inline-item"><a href="https://www.LegacyInsuranceNetwork.com/tos" className="text-light text-decoration-none">Terms of Service</a></li>
          <li className="list-inline-item">|</li>
          <li className="list-inline-item"><a href="https://www.LegacyInsuranceNetwork.com/contact" className="text-light text-decoration-none">Contact Us</a></li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer_v01;
